/**
 * Esqueleto de carga de la grilla de horarios.
 *
 * Es decorativo: `aria-hidden` lo saca del arbol de accesibilidad y el estado real se
 * anuncia una sola vez, con texto, desde el contenedor. Un lector de pantalla no tiene
 * nada que hacer con doce rectangulos grises.
 *
 * La animacion se apaga sola con `prefers-reduced-motion` (ver `publico.css`).
 */

interface PropiedadesEsqueleto {
  readonly filas?: number;
}

export function EsqueletoGrilla({ filas = 12 }: PropiedadesEsqueleto): React.JSX.Element {
  return (
    <div className="esqueleto" aria-hidden="true">
      {Array.from({ length: filas }, (_, indice) => (
        <span className="esqueleto__bloque" key={indice} />
      ))}
    </div>
  );
}
